import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stats-animation-wrapper" }
const _hoisted_2 = { class: "stats-rotator" }

import { ref, toRefs } from "vue";
import { useLogger } from "vue-logger-plugin";

// Define Component Input Properties

export default /*#__PURE__*/_defineComponent({
  __name: 'SiteStats',
  props: {
    numberOfStats: Number,
},
  setup(__props) {

const props = __props;



// get back props that we need to use
const { numberOfStats } = toRefs(props);
// use the logger
const logger = useLogger();
const stat = ref(1);

// every 3 seconds show a new stat
setInterval(() => {
    let value = stat.value;
    // blank out the current stat
    document.getElementsByClassName(`stat0${value}`)[0].innerHTML = "";

    // increase the current stat we want to show but rotate to first one
    value++;
    if (value > numberOfStats?.value) {
        value = 1;
    }

    stat.value = value;
    logger.debug("moving to new stat", stat.value);
}, 9000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, 'stat0' + stat.value)
        ]),
        _: 3
      })
    ])
  ]))
}
}

})